import React, { useState } from "react";
import './ulds.css';
import { Helmet } from "react-helmet";
import ScrollToTop from "../../../../components/scrollToTop/scrollToTop";
import Swal from "sweetalert2";

const simulatedData = [
    {
        flight: "AM0123/25MAY",
        year: "2025",
        origin: "NRT",
        destiny: "MEX",
        guides: 25,
        pieces: 319,
        weight: 11244,
        ata_date: "2023-12-16",
        ata_hour: "09:28",
        plane_type: "Wide Body",
        coordinator: "AGUSTIN MATIAS",
        ULD: 6,
        XP: 0,
        PL: 0,
        tractorista: "JUANITO",
        observations: "OK"
    },
    {
        flight: "AM0456/12JAN",
        year: "2024",
        origin: "JFK",
        destiny: "MEX",
        guides: 18,
        pieces: 210,
        weight: 8765,
        ata_date: "2025-01-12",
        ata_hour: "14:15",
        plane_type: "Wide Body",
        coordinator: "MARIA GONZALEZ",
        ULD: 5,
        XP: 1,
        PL: 0,
        tractorista: "PEDRO",
        observations: "OK"
    },
    {
        flight: "AM0789/03FEB",
        year: "2024",
        origin: "CDG",
        destiny: "GDL",
        guides: 12,
        pieces: 150,
        weight: 6543,
        ata_date: "2025-02-03",
        ata_hour: "22:40",
        plane_type: "Narrow Body",
        coordinator: "JUAN PEREZ",
        ULD: 3,
        XP: 0,
        PL: 0,
        tractorista: "CARLOS",
        observations: "OK"
    },
    {
        flight: "AM0234/20MAR",
        year: "2025",
        origin: "MAD",
        destiny: "MEX",
        guides: 20,
        pieces: 305,
        weight: 10567,
        ata_date: "2025-03-20",
        ata_hour: "07:55",
        plane_type: "Wide Body",
        coordinator: "CARLOS RAMIREZ",
        ULD: 6,
        XP: 0,
        PL: 1,
        tractorista: "LUCHO",
        observations: "OK"
    },
    {
        flight: "AM0678/15APR",
        year: "2025",
        origin: "LAX",
        destiny: "MTY",
        guides: 10,
        pieces: 120,
        weight: 4520,
        ata_date: "2025-04-15",
        ata_hour: "12:30",
        plane_type: "Narrow Body",
        coordinator: "LUISA MARTINEZ",
        ULD: 2,
        XP: 0,
        PL: 0,
        tractorista: "MARIO",
        observations: "OK"
    },
    {
        flight: "AM0912/07MAY",
        year: "2023",
        origin: "ORD",
        destiny: "MEX",
        guides: 15,
        pieces: 198,
        weight: 7820,
        ata_date: "2025-05-07",
        ata_hour: "18:25",
        plane_type: "Wide Body",
        coordinator: "ROBERTO LOPEZ",
        ULD: 4,
        XP: 0,
        PL: 0,
        tractorista: "RAUL",
        observations: "OK"
    },
    {
        flight: "AM0567/28JUN",
        year: "2023",
        origin: "YYZ",
        destiny: "CUN",
        guides: 9,
        pieces: 140,
        weight: 5230,
        ata_date: "2025-06-28",
        ata_hour: "20:45",
        plane_type: "Narrow Body",
        coordinator: "ANDREA TORRES",
        ULD: 2,
        XP: 0,
        PL: 0,
        tractorista: "PABLO",
        observations: "OK"
    },
    {
        flight: "AM0345/10JUL",
        year: "2023",
        origin: "MIA",
        destiny: "MEX",
        guides: 22,
        pieces: 275,
        weight: 9670,
        ata_date: "2025-07-10",
        ata_hour: "06:50",
        plane_type: "Wide Body",
        coordinator: "FERNANDO DIAZ",
        ULD: 5,
        XP: 0,
        PL: 0,
        tractorista: "SERGIO",
        observations: "OK"
    },
    {
        flight: "AM0987/18AUG",
        year: "2024",
        origin: "FRA",
        destiny: "MEX",
        guides: 17,
        pieces: 245,
        weight: 8934,
        ata_date: "2025-08-18",
        ata_hour: "11:05",
        plane_type: "Wide Body",
        coordinator: "PATRICIA MENDOZA",
        ULD: 4,
        XP: 0,
        PL: 1,
        tractorista: "JAVIER",
        observations: "OK"
    },
    {
        flight: "AM0765/09SEP",
        year: "2022",
        origin: "BOG",
        destiny: "MEX",
        guides: 13,
        pieces: 167,
        weight: 6011,
        ata_date: "2025-09-09",
        ata_hour: "15:35",
        plane_type: "Narrow Body",
        coordinator: "DANIEL REYES",
        ULD: 3,
        XP: 0,
        PL: 0,
        tractorista: "ALEJANDRO",
        observations: "OK"
    },
    {
        flight: "AM0543/22OCT",
        year: "2025",
        origin: "SCL",
        destiny: "MEX",
        guides: 19,
        pieces: 289,
        weight: 10045,
        ata_date: "2025-10-22",
        ata_hour: "08:20",
        plane_type: "Wide Body",
        coordinator: "VERONICA CASTRO",
        ULD: 5,
        XP: 0,
        PL: 0,
        tractorista: "RICARDO",
        observations: "OK"
    }
];

function ULDS () {
    const [masterData, setMasterData] = useState(null);
    const [view, setView] = useState('input');
    const [error, setError] = useState('');
    const [flight, setFlight] = useState('');
    const [year, setYear] = useState(new Date().getFullYear().toString());
    const [flightData, setFlightData] = useState(null);

    const formatFlight = (value) => {
        const regex = /^([A-Z]{2})(\d{1,4})\/(\d{2})([A-Z]{3})$/i;
        const match = value.toUpperCase().match(regex);

        if (!match) return value.toUpperCase(); // si no matchea, solo convierte a mayúsculas

        const [, airline, number, day, month] = match;
        const paddedNumber = number.padStart(4, '0');
        return `${airline}${paddedNumber}/${day}${month.toUpperCase()}`;
    };

    const handleInputChange = (e) => {
        const input = e.target.value;
        const formatted = formatFlight(input);
        setFlight(formatted);

        if (error) setError('');
    };

    const generateYears = () => {
        const startYear = 2019;
        const currentYear = new Date().getFullYear();
        const nextYear = currentYear + 1;
        const years = [];

        for (let y = startYear; y <= nextYear; y++) {
            years.push(y.toString());
        }

        return years;
    };

    const handleYearChange = (e) => {
        setYear(e.target.value);
    };

    const handleAplicar = () => {
        const result = simulatedData.filter(
            (item) => item.flight === flight && item.year === year
        );
        if (result.length === 0) {
            setError("No se encontró el vuelo con ese año.");
            setFlightData([]);
        } else {
            setError("");
            setFlightData(result);
        }
    };

    const handleTodo = () => {
        setError("");
        setFlightData(simulatedData);
    };

    const handleRegistrarULDs = (vuelo) => {
        // Generamos los inputs dinámicos según el número de ULDs
        const uldInputs = Array.from({ length: vuelo.ULD || 0 }, (_, index) => {
            return `
            <div class="col-4 mb-2">
                <label class="form-label">ID ULD</label>
                <input type="text" class="form-control" id="uld-${index}" />
            </div>
            `;
        }).join("");

        Swal.fire({
            title: `<strong>Check-In Vuelo</strong>`,
            width: "900px",
            html: `
            <div class="container-fluid text-start">
                <p><b>Vuelo:</b> ${vuelo.flight} &nbsp;&nbsp; <b>Año:</b> ${vuelo.year}</p>
                <hr/>
                <div class="row mb-2">
                <div class="col-3"><b>ATA Fecha:</b> ${vuelo.ata_date}</div>
                <div class="col-3"><b>ATA Hora:</b> ${vuelo.ata_hour}</div>
                <div class="col-3"><b>Tipo de avión:</b> ${vuelo.plane_type}</div>
                <div class="col-3"><b>Coordinador:</b> ${vuelo.coordinator}</div>
                </div>
                <hr/>
                <h5 class="text-center">Convoy 1</h5>
                <div class="row mb-2">
                <div class="col-2"><b>ULD</b><br/>${vuelo.ULD || 0}</div>
                <div class="col-2"><b>XP</b><br/>${vuelo.XP || 0}</div>
                <div class="col-2"><b>PL</b><br/>${vuelo.PL || 0}</div>
                <div class="col-3"><b>Tractorista</b><br/>${vuelo.tractorista || "-"}</div>
                <div class="col-3"><b>Observaciones</b><br/>${vuelo.observations || "-"}</div>
                </div>
                <div class="row">${uldInputs}</div>
                <div id="uld-error-msg" class="mt-3"></div>
            </div>
            `,
            focusConfirm: false,
            showCancelButton: true,
            cancelButtonText: "Cerrar",
            confirmButtonText: "Guardar",
            customClass: {
            popup: "swal-wide",
            confirmButton: "btn btn-ok mx-2",
            cancelButton: "btn btn-cerrar mx-2",
            },
            buttonsStyling: false,
            preConfirm: () => {
            // Leer los valores de los inputs ULD
            const values = [];
            let allFilled = true;

            for (let i = 0; i < (vuelo.ULD || 0); i++) {
                const input = document.getElementById(`uld-${i}`);
                const val = (document.getElementById(`uld-${i}`) || {}).value;
                values.push(val || "");

                // Si hay algún input vacío, marcamos error
                if (!val) {
                    allFilled = false;
                    input.classList.add("is-invalid");
                } else {
                    input.classList.remove("is-invalid");
                }
            }
            const errorDiv = document.getElementById("uld-error-msg");

            if (!allFilled) {
                errorDiv.innerHTML = `
                    <div class="alert alert-danger py-2 mb-0" role="alert">
                        Por favor llenar todos los campos.
                    </div>
                `;
                return false;
            } else {
                errorDiv.innerHTML = ""; // limpia el mensaje si ya están llenos
                return values;
            }
            },
        }).then((result) => {
            if (result.isConfirmed && result.value) {
            console.log("ULDs registrados:", result.value);
            Swal.fire({
                title: "¡Guardado!",
                text: "Los ULDs fueron registrados.",
                icon: "success",
                confirmButtonText: "OK",
            });
            }
        });
    };

    return(
        <>
            <Helmet>
                <title>Horus | ULD's</title>
            </Helmet>
            <ScrollToTop />

            <div className="container-fluid">
                <div className="row justify-content-center">
                    <div className="col-3">
                        <label for="inputMaster" class="amc-label">Vuelo</label>
                        <input 
                            type="text"
                            class="form-control"
                            id="name_flight"
                            value={flight}
                            onChange={handleInputChange}
                        />
                        {error && <small className="text-danger">{error}</small>}
                    </div>
                    <div className="col-3">
                        <label for="inputSelect" class="amc-label">Año</label>
                        <select 
                            className="form-select" 
                            name="year" 
                            id="year"
                            value={year}
                            onChange={handleYearChange}
                        >
                            {generateYears().map((y) => (
                                <option key={y} value={y}>
                                    {y}
                                </option>
                            ))}
                        </select>

                        
                    </div>

                    <div className="col-12 mt-3 d-flex justify-content-center gap-3">
                        <button className='btnn' onClick={handleAplicar}>Aplicar</button>
                        <button className='btnn' onClick={handleTodo}>Todo</button>
                    </div>
                </div>

                {flightData && (
                    <div className="row mt-4">
                        <div className="col-12">
                            <table className="table table-preve text-center">
                                <thead>
                                    <tr>
                                        <th style={{ backgroundColor: '#020C41', color: 'white' }}>Vuelo</th>
                                        <th style={{ backgroundColor: '#020C41', color: 'white' }}>Año</th>
                                        <th style={{ backgroundColor: '#020C41', color: 'white' }}>Origen</th>
                                        <th style={{ backgroundColor: '#020C41', color: 'white' }}>Destino</th>
                                        <th style={{ backgroundColor: '#020C41', color: 'white' }}>Guías</th>
                                        <th style={{ backgroundColor: '#020C41', color: 'white' }}>Piezas</th>
                                        <th style={{ backgroundColor: '#020C41', color: 'white' }}>Peso</th>
                                        <th style={{ backgroundColor: '#020C41', color: 'white' }}>Check-in</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {flightData.map((item, index) => (
                                        <tr key={index}>
                                            <td>{item.flight}</td>
                                            <td>{item.year}</td>
                                            <td>{item.origin}</td>
                                            <td>{item.destiny}</td>
                                            <td>{item.guides}</td>
                                            <td>{item.pieces}</td>
                                            <td>{item.weight}</td>
                                            <td>
                                                <button className="btnn" onClick={() => handleRegistrarULDs(item)}>
                                                    Registrar ULDs
                                                </button>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                )}
            </div>
        </>
    );
}

export default ULDS;